<script>
	import { getTraitColor } from '../helpers';
    import { getNewIcon } from '../../card_images';
	import "../shared.css";

	export let trait;
	export let prefix = ''; // e.g. 'non-' for bot chart rows
	$: color = getTraitColor(trait);
	$: traitLabel = (prefix + trait.replace('-', ' ')).toUpperCase();
</script>

<div class="trait-chip" style="--bgc:{color.background};--c:{color.label};">
	<img src={getNewIcon(trait)} />
	<div class="label font-heading">{traitLabel}</div>
</div>

<style lang="scss">
	.trait-chip {
		background-color: var(--bgc);
		display: inline-flex;
		height: 1.1em;
		border-radius: calc(var(--width) / 0.574); //500px;
		color: var(--c);
		padding: 0 0.3em 0 0;
		vertical-align: text-bottom;
		align-items: center;
		gap: calc(var(--width) / 143.5); //2px;
		& > :global(img) {
			width: auto;
			height: 100%;
		}
	}
	.label {
		font-size: 0.9em;
		margin-top: -0.05em;
		text-indent: 0;
	}
</style>
